import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {setLoginDetails, setPersonalInfoDetails} from "../../actions/actions";
import { Link } from "react-router-dom";
import {encryptData, projectLogo, projectName} from "../../resources/constants";
import { showAlert } from "../common/sweetalert/sweetalert";
import axios from "axios";
import { serverLink } from "../../resources/url";
import {toast} from "react-toastify";

function Login(props) {
    const [login, setLogin] = useState({
        StudentID: "",
        Password: "",
    });

    const onEdit = (e) => {
        setLogin({
            ...login,
            [e.target.name]: e.target.value,
        });
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const sendData = {
            username: login.StudentID,
            password: encryptData(login.Password),
        };

        if (login.StudentID === "") {
            showAlert("Empty Field", "Please enter your Student ID or Username", "error");
            return false;
        }

        if (login.Password === "") {
            showAlert("Empty Field", "Please enter your Password", "error");
            return false;
        }

        toast.info("Login.... Please wait");

        await axios
            .post(`${serverLink}login/student/login`, sendData)
            .then((result) => {
                if (result.data.message === "success") {
                    // toast.success("Login successful");
                    props.setOnLoginDetails(result.data.userData);
                    props.setOnPersonalInfoDetails(result.data.personalInfo);
                    setTimeout(function () {
                        window.location.href = '/';
                    }, 100)
                } else if (result.data.message === 'personal_info_not_found') {
                    showAlert(
                        "INVALID",
                        "Something went wrong fetching student data!",
                        "error"
                    );
                } else {
                    showAlert(
                        "INVALID",
                        "Invalid login credentials. Please check and try again!",
                        "error"
                    );
                }
            })
            .catch((error) => {
                showAlert(
                    "NETWORK ERROR",
                    "Please check your network connection and try again!",
                    "error"
                );
            });
    };

    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-5 mx-auto">
                        <form onSubmit={onSubmit} >
                            <div className="d-flex flex-column justify-content-between vh-100">
                                <div className=" mx-auto  text-center">
                                    <img src={projectLogo} className="img-fluid" alt="Logo" style={{height: '120px', marginTop: '150px', marginBottom: '-60px'}}/>
                                </div>
                                <div className="card" style={{marginTop: '-40px'}}>
                                    <div className="card-body p-3">
                                        <div className="mb-5">
                                            <h2 className="mb-2 text-center">Student Portal</h2>
                                            <p className="mb-0 text-center">Please enter your details to sign in</p>
                                        </div>

                                        <div className="mb-3 ">
                                            <label className="form-label">Student ID or Username</label>
                                            <div className="input-icon mb-3 position-relative">
											<span className="input-icon-addon">
												<i className="ti ti-mail"></i>
											</span>
                                                <input type="text" name="StudentID"
                                                       value={login.StudentID}
                                                       onChange={onEdit}
                                                       autoComplete="off"
                                                       placeholder="Please enter your StudentID or Username" className="form-control"/>
                                            </div>
                                            <label className="form-label">Password</label>
                                            <div className="pass-group">
                                                <input type="password" name="Password" className="pass-input form-control" value={login.Password}
                                                       onChange={onEdit}
                                                       autoComplete="off"
                                                       placeholder="Please enter your Password"/>
                                                    <span className="ti toggle-password ti-eye-off"></span>
                                            </div>
                                        </div>

                                        <div className="form-wrap form-wrap-checkbox mb-3">
                                            <div className="d-flex align-items-center">

                                            </div>
                                            <div className="text-end ">
                                                <Link to={"/forgot-password"}  className="link-danger">Forgot Password ?</Link>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <button type="submit" className="btn btn-primary w-100">Sign In</button>
                                        </div>
                                        <div className="text-center">

                                        </div>
                                    </div>
                                </div>
                                <div className="p-4 text-center">
                                    <p className="mb-0 ">Copyright &copy; 2024 - {projectName}</p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnPersonalInfoDetails: (p) => {
            dispatch(setPersonalInfoDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
